import platformApi from "api/platform";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
import { PlatformPayload, PlatformSubmitForm } from "models/platform";
import { call, put, takeLatest } from "redux-saga/effects";
import { platformAction } from "./platformSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { Platform } from "models/platform";
import { toast } from "react-toastify";

function* getPlatformList(action: PayloadAction<PlatformPayload>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.getPlatformList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(platformAction.getPlatformSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(platformAction.getPlatformFailed(errorData));
  }
}

function* getPlatformListById(action: PayloadAction<PlatformPayload>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.getPlatformById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(platformAction.getPlatformByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(platformAction.getPlatformByIdFailed(errorData));
  }
}

function* addPlatform(action: PayloadAction<Platform>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.addPlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(platformAction.addPlatformSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(platformAction.addPlatformFailed(errorData));
  }
}

function* deletePlatform(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.deletePlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(platformAction.deletePlatformSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(platformAction.deletePlatformFailed(errorData));
  }
}

function* updatePlatform(action: PayloadAction<PlatformSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.updatePlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(platformAction.updatePlatformSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(platformAction.updatePlatformFailed(errorData));
  }
}

function* getImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      platformApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(platformAction.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(platformAction.getImageUrlFailed(errorData));
  }
}

export default function* platformSaga() {
  yield takeLatest(platformAction.getPlatforms.type, getPlatformList);
  yield takeLatest(platformAction.getPlatformById.type, getPlatformListById);
  yield takeLatest(platformAction.addPlatform.type, addPlatform);
  yield takeLatest(platformAction.deletePlatform.type, deletePlatform);
  yield takeLatest(platformAction.getImageUrl.type, getImageUrl);
  yield takeLatest(platformAction.updatePlatform.type, updatePlatform);
}
